// First-party analytics tracker — privacy friendly (anonymous ids, no IP storage).
// Batches events and flushes via sendBeacon/fetch to POST /api/track.

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SESSION_TTL = 30 * 60 * 1000;

const uuid = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `${Date.now()}-${Math.random().toString(36).slice(2)}`;

function getVid() {
  let v = localStorage.getItem("tbl_vid");
  if (!v) {
    v = uuid();
    localStorage.setItem("tbl_vid", v);
  }
  return v;
}

function getSid() {
  const now = Date.now();
  let sid = null;
  let ts = 0;
  try {
    const raw = JSON.parse(sessionStorage.getItem("tbl_sid") || "{}");
    sid = raw.sid;
    ts = raw.ts || 0;
  } catch {
    /* fresh session */
  }
  if (!sid || now - ts > SESSION_TTL) sid = uuid();
  sessionStorage.setItem("tbl_sid", JSON.stringify({ sid, ts: now }));
  return sid;
}

// Landing-page UTM + referrer captured once per session (SPA navigations lose them)
function getAttribution() {
  const raw = sessionStorage.getItem("tbl_attr");
  if (raw) {
    try {
      return JSON.parse(raw);
    } catch {
      /* recompute */
    }
  }
  const q = new URLSearchParams(window.location.search);
  const attr = {
    utm_source: q.get("utm_source") || "",
    utm_medium: q.get("utm_medium") || "",
    utm_campaign: q.get("utm_campaign") || "",
    referrer: document.referrer || "",
  };
  sessionStorage.setItem("tbl_attr", JSON.stringify(attr));
  return attr;
}

let queue = [];
let timer = null;

const isAdminPath = () => window.location.pathname.startsWith("/admin");

export function flushAnalytics() {
  if (!queue.length) return;
  const events = queue;
  queue = [];
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  const payload = JSON.stringify({ events });
  const blob = new Blob([payload], { type: "application/json" });
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(`${API_BASE}/track`, blob)) return;
  } catch {
    /* fall through to fetch */
  }
  fetch(`${API_BASE}/track`, {
    method: "POST",
    body: payload,
    headers: { "Content-Type": "application/json" },
    keepalive: true,
  }).catch(() => {});
}

function push(evt) {
  if (isAdminPath()) return;
  queue.push(evt);
  if (queue.length >= 10) flushAnalytics();
  else if (!timer) timer = setTimeout(flushAnalytics, 4000);
}

const base = () => ({ ...getAttribution(), sid: getSid(), vid: getVid(), path: window.location.pathname });

export function trackPageview() {
  push({ type: "pageview", title: document.title, ...base() });
}

export function trackEvent(name, props = {}) {
  push({ type: "event", name, props, ...base() });
}

if (typeof window !== "undefined") {
  // Global handle so any component can fire events without an import cycle
  window.__tblTrack = trackEvent;
  window.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") flushAnalytics();
  });
  window.addEventListener("pagehide", flushAnalytics);
}
